<script>
export default {
  name: "IconHelp"
};
</script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 0c4.412 0 8 3.588 8 8s-3.588 8-8 8-8-3.588-8-8 3.588-8 8-8zm0 1.261A6.745 6.745 0 001.26 8c0 1.746.668 3.34 1.762 4.538l.142.15A6.72 6.72 0 008 14.738 6.748 6.748 0 0014.739 8a6.746 6.746 0 00-6.74-6.739zm-.197 10.091l.054.002a.79.79 0 01.75.748l.002.054v.363a.794.794 0 01-.806.804.793.793 0 01-.803-.75L7 12.518v-.363c0-.436.324-.776.75-.802l.054-.002zm.269-8.312h.095c1.8.042 3.13 1.24 3.175 2.89l.001.112c0 1.593-1.065 2.719-2.817 3.043l-.047.009-.086 1.198c-.025.312-.23.551-.526.575l-.05.003H7.79c-.304 0-.524-.222-.57-.522l-.006-.05-.147-1.734a.659.659 0 01.157-.488.688.688 0 01.49-.236c1.374-.086 2.157-.718 2.192-1.7l.001-.098c0-.964-.768-1.662-1.862-1.662-.79 0-1.474.325-2.1 1.007l-.074.083a.707.707 0 01-.547.266.654.654 0 01-.671-.66.73.73 0 01.164-.457c.872-1.04 1.88-1.548 3.136-1.578l.119-.001z"
      fill="currentColor"
      fill-rule="nonzero"
    />
  </svg>
</template>
